import { ENTERPRISE_BASE_URL } from '../constants';

import { api } from './base';

import type {
	EnterpriseAutopilotsResponse,
	EnterpriseResponse,
	RelevantEnterprisePeopleResponse,
	User,
} from './types';

export const enterpriseApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getEnterprise: builder.query<EnterpriseResponse, void>({
			query() {
				return {
					url: `${ENTERPRISE_BASE_URL}/hd`,
					method: 'GET',
				};
			},
			providesTags: ['Enterprise'],
		}),
		getEnterpriseAutopilots: builder.query<EnterpriseAutopilotsResponse, void>({
			query() {
				return {
					url: `${ENTERPRISE_BASE_URL}/autopilots`,
					method: 'GET',
				};
			},
			providesTags: ['EnterpriseUsers'],
		}),
		getEnterpriseUsers: builder.query<User[], string>({
			query(enterpriseId) {
				if (!enterpriseId) return '';
				return {
					url: `${ENTERPRISE_BASE_URL}/${enterpriseId}/users`,
					method: 'GET',
				};
			},
		}),
		getRelevantEnterprisePeople: builder.query<
			RelevantEnterprisePeopleResponse,
			{ enterpriseId: string; searchTerm: string }
		>({
			query: ({ enterpriseId, searchTerm }) => ({
				url: `${ENTERPRISE_BASE_URL}/${enterpriseId}/relevant_users/${searchTerm}`,
				method: 'GET',
			}),
		}),
	}),
});

export const {
	useGetEnterpriseQuery,
	useGetEnterpriseAutopilotsQuery,
	useGetEnterpriseUsersQuery,
	useGetRelevantEnterprisePeopleQuery,
} = enterpriseApi;
